import styled from 'styled-components';
import breakpoints from 'theme/atoms/breakpoints';
import colours from 'theme/atoms/colours';
import * as Cards from 'theme/components/Cards.style';
import * as Text from 'theme/components/Text.style';

export const Card = styled(Cards.BaseCard)`
  gap: 40px;
  max-width: 600px;

  @media (max-width: ${breakpoints.laptop}) {
    margin-top: 20px;
  }
`;

export const CenteredWrapper = styled('div')`
  align-items: center;
  display: flex;
  flex: 1;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

export const TextBlock = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Subtitle = styled(Text.P2)`
  color: ${colours.neutral[600]};
`;

export const PromptList = styled('ul')`
  display: flex;
  flex-direction: column;
  gap: 30px;
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const PromptItem = styled('li')`
  align-items: center;
  display: flex;
  gap: 10px;
`;

export const WaveformIcon = styled('span')`
  align-items: center;
  color: ${colours.primary[500]};
  display: inline-flex;
  flex-shrink: 0;
  height: 30px;
  justify-content: center;
  width: 30px;

  svg {
    height: 22px;
    width: 22px;
  }
`;
